export const SKINS = {
  standard: 'standard',
  premium: 'premium',
  dark: 'dark',
  light: 'light',
  destructive: 'destructive',
  standardLight: 'standard-light',
} as const;

export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
} as const;

export const WEIGHT = {
  thin: 'thin',
  secondary: 'normal',
  bold: 'bold',
} as const;

export const UNDERLINE = {
  none: 'none',
  onHover: 'onHover',
  always: 'always',
} as const;
